export default __webpack_public_path__ + "static/media/fireTruckSmall.33b9e659.jpg";